import { render, staticRenderFns } from "./Introduccion.vue?vue&type=template&id=bd90e658&scoped=true"
import script from "./Introduccion.vue?vue&type=script&setup=true&lang=js"
export * from "./Introduccion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd90e658",
  null
  
)

export default component.exports